




























































































import Vue, { PropOptions } from 'vue';
import ContentCard from '@/web/components/products/ContentCard.vue';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import LibraryAddMedia from '@/web/views/admin/media-library/LibraryAddMedia.vue';
import { errorToMessage } from '@/core/utils/errors';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

interface Props {
  lesson: PropOptions;
}
interface LocalState {
  draggableDelay: number;
  lessonLocal: LessonResponse | null;
}

export default Vue.extend({
  name: 'LessonEdit',
  components: { ContentCard, draggable },
  mixins: [TeacherPermissionsMixin],
  data(): LocalState {
    return {
      draggableDelay,
      lessonLocal: null,
    };
  },
  props: {
    lesson: {
      type: Object as () => LessonResponse,
      default: null,
    },
  } as Props,
  methods: {
    async duplicate(): Promise<void> {
      this.$emit('duplicate', this.lesson);
    },
    async remove(): Promise<void> {
      this.$emit('remove', this.lesson);
    },
    removeLessonContent(id: number): void {
      try {
        this.$store.dispatch('product/removeProductLessonContent', {
          productId: this.lessonLocal?.product,
          lessonId: this.lessonLocal?.id,
          contentId: id,
        });
        if (this.lessonLocal)
          this.lessonLocal.content = this.lessonLocal.content.filter(
            c => c.id != id
          );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to delete content',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async showAddMediaForm(): Promise<void> {
      this.$modal.show(
        MediaFormModal,
        {
          showSelectMedia: true,
          showEditMedia: false,
          videoUploadAllowed: this.videoUploadAllowed,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'media-selected': async (content: any[]) => {
            if (this.lessonLocal)
              this.lessonLocal.content = [
                ...content,
                ...this.lessonLocal.content,
              ];
          },
          'media-added': media => {
            this.showEditMedia(media);
          },
        }
      );
    },
    showEditMedia(media) {
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData: media,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async media => {
            if (this.lessonLocal)
              this.lessonLocal.content = [media, ...this.lessonLocal.content];
          },
        }
      );
    },
  },
  watch: {
    lessonLocal: {
      handler(lessonLocal, oldLessonLocal) {
        if (lessonLocal?.id === oldLessonLocal?.id) {
          // Changing lesson data
          this.$set(this.lessonLocal, 'isDirty', true);
        }
      },
      deep: true,
    },
    lesson: {
      immediate: true,
      handler(lesson) {
        this.lessonLocal = lesson;
      },
    },
  },
});
